import './components/auth-modal';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';
import { API_ENDPOINT } from './constants';
import './main'

interface Winner {
  name: string;
  minecraftName: string;
  skinUrl?: string;
}

interface LeaderboardEntry {
  rank: number;
  name: string;
  wins: number;
}

class TournamentApp {
  private authModal: any;
  private mockWinner: Winner = {
    name: "JackB4D11",
    minecraftName: "JackB4D11",
    skinUrl: "https://crafthead.net/avatar/JackB4D11"
  };

  private mockLeaderboard: LeaderboardEntry[] = [
    { rank: 1, name: "JackB4D11", wins: 1 },
  ];

  constructor() {
    this.initializeAuth();
    this.setupEventListeners();
    this.loadData();
  }

  private initializeAuth() {
    const authBtn = document.getElementById('auth-btn') as HTMLButtonElement;

    onAuthStateChanged(auth, (user) => {
      if (user) {
        authBtn.textContent = 'Account';
        authBtn.onclick = () => window.location.href = '/account';
      } else {
        authBtn.textContent = 'Sign In';
        authBtn.onclick = () => this.showAuthModal();
      }
    });
  }

  private setupEventListeners() {
    this.authModal = document.getElementById('auth-modal');

    // Join tournament buttons
    const joinBtn1 = document.getElementById('join-tournament-btn');
    const joinBtn2 = document.getElementById('join-tournament-btn-2');

    if (joinBtn1) {
      joinBtn1.addEventListener('click', () => this.handleJoinTournament());
    }

    if (joinBtn2) {
      joinBtn2.addEventListener('click', () => this.handleJoinTournament());
    }

    // Close modal when clicking outside
    this.authModal?.addEventListener('click', (e: Event) => {
      if (e.target === this.authModal) {
        this.authModal.hidden = true;
      }
    });
  }

  private showAuthModal() {
    if (this.authModal) {
      this.authModal.show();
    }
  }

  private handleJoinTournament() {
    if (auth.currentUser) {
      window.location.href = 'account.html';
    } else {
      this.showAuthModal();
    }
  }

  private async loadData() {
    await this.loadWinner();
    await this.loadLeaderboard();
  }

  private async loadWinner() {
    try {
      const response = await fetch(`${API_ENDPOINT}/api/tournament/winner`, {
        credentials: 'include',
      }).catch(() => null);

      let winner = this.mockWinner;
      if (response?.ok) {
        winner = await response.json();
      }

      this.displayWinner(winner);
    } catch (error) {
      console.error('Error loading winner:', error);
      this.displayWinner(this.mockWinner);
    }
  }

  private async loadLeaderboard() {
    try {
      const response = await fetch(`${API_ENDPOINT}/api/tournament/leaderboard`, {
        credentials: 'include',
      }).catch(() => null);

      let leaderboard = this.mockLeaderboard;
      if (response?.ok) {
        leaderboard = await response.json();
      }

      this.displayLeaderboard(leaderboard);
    } catch (error) {
      console.error('Error loading leaderboard:', error);
      this.displayLeaderboard(this.mockLeaderboard);
    }
  }

  private displayWinner(winner: Winner) {
    const nameElement = document.getElementById('winner-name');
    const skinElement = document.getElementById('winner-skin') as HTMLImageElement;
    const display = document.getElementById('winner-display');

    if (nameElement) {
      nameElement.textContent = winner.minecraftName;
    }

    if (skinElement && winner.skinUrl) {
      skinElement.src = winner.skinUrl;
      skinElement.alt = `${winner.minecraftName}'s Minecraft skin`;
      skinElement.classList.remove('hidden');

      // Hide the loading text
      const loadingText = display?.querySelector('span');
      if (loadingText) {
        loadingText.style.display = 'none';
      }
    }
  }

  private displayLeaderboard(leaderboard: LeaderboardEntry[]) {
    const tbody = document.getElementById('leaderboard-body');
    if (!tbody) return;

    tbody.innerHTML = leaderboard.map(entry => `
      <tr class="border-t border-gray-700">
        <td class="px-6 py-4">#${entry.rank}</td>
        <td class="px-6 py-4">${entry.name}</td>
        <td class="px-6 py-4">${entry.wins}</td>
      </tr>
    `).join('');
  }
}

// Initialize the app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new TournamentApp();
});
